/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Windows_Step3Inputs */

const en_gc_resources_download_windows_step3 = /** @type {(inputs: Gc_Resources_Download_Windows_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch GridCraft from the Start menu and open an XLSX file.`)
};

const zh_gc_resources_download_windows_step3 = /** @type {(inputs: Gc_Resources_Download_Windows_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从开始菜单启动 GridCraft，打开 XLSX 文件。`)
};

/**
* | output |
* | --- |
* | "Launch GridCraft from the Start menu and open an XLSX file." |
*
* @param {Gc_Resources_Download_Windows_Step3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_windows_step3 = /** @type {((inputs?: Gc_Resources_Download_Windows_Step3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Windows_Step3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_windows_step3(inputs)
	return zh_gc_resources_download_windows_step3(inputs)
});
export { gc_resources_download_windows_step3 as "gc.resources.download.windows.step3" }